module.exports = __webpack_public_path__ + "static/media/c_3.0f677c83.png";